import clsx from 'clsx';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { I18nContext } from 'src/stores/I18n';
import { LOCALE_TYPE } from 'src/types/locale';
import { NextImage } from '../../elements/NextImage';
import styles from './index.module.scss';

type Props = {
  sizeImmutable?: boolean;
  isSmall?: boolean;
};

export const BuyerCommentLabel: React.FC<Props> = ({ isSmall = false, sizeImmutable = false }) => {
  const { locale } = useRouter();
  const localeResources = useContext(I18nContext);
  return (
    <div className={clsx(styles.container, isSmall && styles.isSmall, sizeImmutable && styles.sizeImmutable)}>
      <div className={clsx(styles.buyerCommentLabelContainer, isSmall && styles.isSmall)}>
        <p className={clsx(styles.buyerCommentLabelText, isSmall && styles.isSmall)}>
          {localeResources.products.buyerCommentLabel.title}
        </p>
      </div>
      {!isSmall && (
        <div className={styles.buyerCommentPatchContainer} data-testid="buyer-comment-patch">
          <div className={styles.commentIconContainer} data-testid="buyer-comment-patch-icon">
            <NextImage
              src={`/kaimono/images/buyerComment/patch/${locale as LOCALE_TYPE}.webp`}
              alt={localeResources.products.buyerCommentLabel.patch.text}
              className={styles.commentIcon}
              width={60}
              height={60}
            />
          </div>
        </div>
      )}
    </div>
  );
};
